export const MEDIA_QUERY_SIZE = {
  mediaQueryXs: 450,
  mediaQuerySm: 600,
  mediaQueryMd: 900,
  mediaQueryLg: 1200,
};

export const HEADER_BREAKPOINT = 973;

export const STORAGE_PROVIDER_HEADER_BREAKPOINT = 880;
